import React from 'react';
import ArticleWrapper from '../../components/ArticleWrapper';

const HMXXinhai = () => (
  <ArticleWrapper articleId="hmx_xinhai">
    <div className="prose prose-invert mx-auto p-6">
      <h1>HMX Xinhai</h1>
      {/* Add your HMX Xinhai article content here */}
      <p>This is a placeholder article for the HMX Xinhai switch. More content coming soon.</p>
    </div>
  </ArticleWrapper>
);

export default HMXXinhai;
